<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh" :disabled="dialogVisible">
    <!-- 未开始-0 或 已结束-2 或 已下架  -->
    <div
      v-if="
        activityInfo.activityStatus === 0 || activityInfo.activityStatus === 2 || errCode == 90130
      "
      :class="$style.pageNative"
    >
      <img
        v-if="activityInfo.activityStatus === 0"
        :src="`${CDN_URL_1}/box_subscribe/unStart.png`"
      />
      <div
        v-if="activityInfo.activityStatus === 0 && errCode != 90130"
        :class="$style.nativeStatus"
      >
        活动将于{{ activityInfo.startTime }}开始
      </div>
      <img
        v-if="activityInfo.activityStatus === 2"
        :src="`${CDN_URL_1}/box_subscribe/end.png`"
      />
      <div
        v-if="activityInfo.activityStatus === 2"
        :class="$style.nativeStatus"
        :style="{height: '90px'}"
      >
        活动已结束
        <p :style="{fontSize: '15px'}">活动礼包请在我的礼包中查看使用</p>
      </div>
      <div v-if="errCode == 90130" :class="$style.nativeStatus">活动已下架</div>
    </div>

    <!-- 进行中-1  -->
    <div
      v-if="activityInfo.activityStatus === 1"
      :class="`${$style.pageContent}`"
    >
      <div :class="$style.activityInfo">
        <div :class="$style.activityPlaces">
          <div v-if="activityInfo.payActivityGameVoList.length > 0">
            <div
              v-for="item in activityInfo.payActivityGameVoList.slice(0, 4)"
              :key="item.payActivityGameId"
              :style="{display:'inline-block', position: 'relative'}"
            >
              <img
                :src="item.icon"
                :class="`${$style.placeIcon} ${
                  item.payActivityGameId == selectPlaceId
                    ? $style.activePlace
                    : ''
                }`"
                @click="onHandlePlace(item.payActivityGameId)"
              />
              <div
                v-if="item.play"
                :class="$style.isPlay"
              >
                最近在玩
              </div>
            </div>
          </div>
          <div
            v-if="activityInfo.payActivityGameVoList.length > 4"
            :class="$style.morePlace"
            @click="openDialog(1)"
          >
            <img :src="`${CDN_URL_1}/box_payAmount/more.png`" />
            <p :class="$style.moreText">更多游戏</p>
          </div>
        </div>
      </div>
      <div
        :class="$style.activityGifts"
        @touchmove.stop
        @touchend.stop
      >
        <div :class="$style.gameInfo">
          <p :class="$style.title">
            {{ curPlaceInfo.gameName }}
          </p>
          <p :class="$style.tag">{{curPlaceInfo.tag }}</p>
          <div :class="$style.button" @click="onSkipDetail(curPlaceInfo.gameId)">下载/查看游戏</div>
        </div> 
        <div v-if="giftList.length>0" :class="$style.giftList">
          <div v-for="item in giftList" :key="item.giftId" :class="$style.giftItem">
            <h3 :class="$style.title">{{ taskName[item.giftId] }}</h3>
            <div :style="{display:'flex',alignItems: 'center',justifyContent: 'space-between'}">
              <img :class="$style.icon" :src="item.giftIcon"/>
              <div :class="$style.info">
                <p :class="$style.content">{{ item.desc }}</p>
              </div>
              <div>
                <div 
                  :class="`${$style.giftBtn} ${item.drawStatus?`${$style.disableBtn}`:''}`"
                  @click="onReceiveGift(item)"
                  >
                  {{item.drawStatus?'已领取':'领取奖励'}}
                </div>
                <p :class="$style.money">{{ refreshText[item.refresh] }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 弹窗 -->
      <ActivityDialog
        :title="dialogTitle"
        :visible="dialogVisible"
        :hideCancel="dialogType != 3"
        :hideSure="dialogType == 1"
        :sureText="sureText"
        cancelText="继续领取奖励"
        @click-sure="onSureDialog"
        @click-cancel="onCloseDialog"
        :herderStyle="{background: '#ffb503'}"
        :dialogStyle="{top: dialogType == 1?'16%':'32%'}"
        :cancelStyle="{filter: 'none'}"
      >
        <template v-slot:main>
          <!-- 更多游戏弹窗 -->
          <div v-if="dialogType == 1" :class="$style.dialog1">
            <h2 :class="$style.dialogTitle">请选择</h2>
            <div :class="$style.dialogPlace">
              <div 
                v-for="item in activityInfo.payActivityGameVoList"
                :key="item.payActivityGameId"
                :class="$style.item"
                @click="onHandlePlace(item.payActivityGameId)"
              >
                <img :src="item.icon" :class="$style.icon"/>
                <div :class="$style.name">{{ item.gameName }}</div>
                <div
                  v-if="item.play"
                  :class="$style.isPlay"
                  :style="{top: '-12px'}"
                >
                  最近在玩
                </div>
              </div>
            </div>
          </div>
          <!-- 不满足活动条件 -->
          <div v-if="dialogType == 2 && curGiftInfo.conditionType == 3" :class="$style.dialog2">
            <p :style="{textAlign: 'center'}"><span>今日</span>在该游戏内<span>累计充值</span>达到{{ curGiftInfo.money }}元即可领取礼包</p>
            <div :class="$style.progress">
              <p :class="$style.text">当前进度</p>
              <p
                :class="$style.percentage"
                :style="{ width: percentage + '%' }"
              ></p>
              <p
                v-if="percentage < 100"
                :class="$style.amount"
                :style="{ left: (percentage == 0 ? 3 : percentage-1) + '%', top:percentage>90 ? '-22px':'8px'  }"
              >
                {{ amount }}
              </p>
              <p :class="$style.typeValue">{{curGiftInfo.money }}</p>
            </div>
          </div>
          <div v-if="dialogType == 2 && curGiftInfo.conditionType == 2" :class="$style.dialog2">
            <p :style="{textAlign: 'center'}"><span>今日</span>登录{{curPlaceInfo.gameName}}即可领取礼包</p>
          </div>
          <div v-if="dialogType == 2 && curGiftInfo.conditionType == 4" :class="$style.dialog2">
            <p :style="{textAlign: 'center'}"><span>今日</span>在该游戏内<span>单笔充值</span>达到{{ curGiftInfo.money }}元即可领取礼包</p>
          </div>
          <!-- 领取成功 -->
          <div v-if="dialogType == 3" :class="$style.dialog3">
            <p :style="{textAlign: 'center',marginBottom: '10px'}">礼包码已存放在</p>
            <p :style="{textAlign: 'center', width: '100%'}"><span>【我的】</span>-<span>【我的礼包】</span>-<span>【活动礼包】</span></p>
          </div>
          <!-- 礼包码生成错误 -->
          <div v-if="dialogType == 4" :class="$style.dialog4">
            <p :style="{textAlign: 'center'}">兑换码生成错误，请联系客服领取备用码</p>
          </div>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  setPageTitle,
  getUserInfo,
  toLogin,
  signInEventTrack,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie, pageLoseTips } from "@/libs/utils";
import {
  getBtPayAmountActivityConfigApi,
  getBtPayAmountActivityGiftsApi,
  receiveBtPayAmountActivityGiftApi,
  sendPoint
} from "@/apis/btBoxActivity";
import { queue } from "../../libs/queue.request";

export default {
  name: "",
  components: {
    PullRefresh,
    ActivityDialog,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      CDN_URL: CDN_URL,
      pageTitle: "",
      activityId: "",
      userInfo: "",
      isLoading: false,
      cookie: null,
      activityInfo: {
        activityStatus: 1,
        startTime: "",
        rule: "",
        broadcast: "",
        payActivityGameVoList: [],
      },
      errCode: "",
      selectPlaceId: "",
      curPlaceInfo: {
        icon: "",
        gameName: "",
        tag: "",
        gameId: "",
      },
      giftList: [],
      dialogVisible: false,
      dialogType: 1, // 1-更多游戏 2-不满足领取条件 3-领取成功 4-礼包码生成错误
      dialogTitle:'更多游戏',
      sureText:'',
      percentage: 1,
      amount:0,
      curGiftInfo:{
        money: 0,
        giftId: 0,
        activityGiftId: 0,
      },
      reqQueue: queue(),
      noticeScrollLocation: 0,
      refreshText:{1:'限兑一次',2:'每日刷新',3:'每周刷新',4:'每月刷新'},
    };
  },
  computed: {
    taskName:function() {
      let taskNameMap = {};
      for (const gift of this.giftList) {
        if (gift.conditionType == 1) {
          taskNameMap[gift.giftId] = '完成盒子登录';
        }
        if (gift.conditionType == 2) {
          taskNameMap[gift.giftId] = `登录《${this.curPlaceInfo.gameName}》`;
        }
        if (gift.conditionType == 3) {
          taskNameMap[gift.giftId] = `累计付费达${gift.money}元`;
        }
        if (gift.conditionType == 4) {
          taskNameMap[gift.giftId] = `单笔付费达${gift.money}元`;
        }
      }
      return taskNameMap;
    }
  },

  created() {
    // 页面初始化
    inithandler();
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      // 错误处理
    }
    setInterval(() => {
      // if (this.noticeScrollLocation < 100) {
        this.noticeScrollLocation = this.noticeScrollLocation - 0.4;
      // }
      if (this.noticeScrollLocation < -53) {
        this.noticeScrollLocation = 0
      }
      
    }, 100);
  },
  activated() {
    setRightTxt('活动规则');
  },
  watch: {
    cookie(value, oldValue){
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      if (!this.cookie) {
        console.log("数据上报异常", data.event,"转为补充数据上报")
        this.reqQueue.add(sendPoint,data)
        return
      }
      console.log("正常数据上报", data.event)
      sendPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      const { history } = this.$router;
      const { id } = history.current.query;
      if (!id || isNaN(id)) {
        pageLoseTips(this.$toast);
        return;
      }
      this.setHeaderContent();
      this.activityId = id;
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActivityMainConfig();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getActivityMainConfig();
        });
      }
    },
    // 获取活动主配置
    getActivityMainConfig() {
      getBtPayAmountActivityConfigApi({ payActivityId: this.activityId })
        .then((res) => {
          const { data } = res;
          this.pageTitle = data.name;
          setPageTitle(data.name);
          this.activityInfo = data;
          if (this.selectPlaceId) {
            this.getBtPayAmountActivityGifts(this.selectPlaceId);
          }
          if (data.payActivityGameVoList.length > 0 && !this.selectPlaceId) {
            this.selectPlaceId = data.payActivityGameVoList[0].payActivityGameId;
            this.getBtPayAmountActivityGifts(data.payActivityGameVoList[0].payActivityGameId);
            this.curPlaceInfo = data.payActivityGameVoList[0];
          }
          this.eventTrack({
            event: "pay_active_page",
            event_field: JSON.stringify({ id: this.activityId,name: data.name }),
          });
        })
        .catch(err => {
          const { code,response } = err;
          if (code) {
            this.errCode = code;
          }
          if (response) {
            const {data} = response;
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
    },
    // 点击游戏会场
    onHandlePlace(payActivityGameId) {
      this.giftList = [];
      this.selectPlaceId = payActivityGameId;
      if (this.activityInfo.payActivityGameVoList.length > 0) {
        let placeInfoItem = {};
        let placeInfoItemIndex = 0;
        this.activityInfo.payActivityGameVoList.map((item,index) => {
          if (item.payActivityGameId == payActivityGameId) {
            placeInfoItemIndex = index;
            placeInfoItem = item;
            this.curPlaceInfo = item;
          }
        });
        const arr = this.activityInfo.payActivityGameVoList.filter((ele,index) => index!= placeInfoItemIndex);
        this.activityInfo = {
          ...this.activityInfo,
          payActivityGameVoList: [placeInfoItem, ...arr]
        }
      }
      this.dialogVisible = false;
      this.getBtPayAmountActivityGifts(payActivityGameId);
      this.eventTrack({
        event: "pay_active_game_icon",
        event_field: JSON.stringify({ id: this.activityId,name: this.pageTitle }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId
      });
    },
    // 获取游戏会场礼包信息
    getBtPayAmountActivityGifts(payActivityGameId){
      let params = {
        payActivityId: this.activityId,
        payActivityGameId
      }
      getBtPayAmountActivityGiftsApi(params).then(res => {
        const { data } = res;
        if (data) {
          this.giftList = data;
        }
      }).catch(err => {
        console.log("err:", err)
      })
    },
    // 领取礼包操作
    onReceiveGift(data){
      const { drawStatus,giftId,giftName,money,conditionType } = data;
      this.curGiftInfo = data;
      if (drawStatus) {
        this.openDialog(3, false);
        // 已领取
        return
      }
      receiveBtPayAmountActivityGiftApi({activityGiftId: data.activityGiftId}).then(res => {
        const {data, code} = res;
        this.amount = data.amount;
        this.getBtPayAmountActivityGifts(this.selectPlaceId);
        this.eventTrack({
          event: "pay_active_get_gift",
          event_field: JSON.stringify({ 
            id: this.activityId,
            name: this.pageTitle,
            gift_id:giftId,
            gift_name:giftName,
            task_name: this.taskName[giftId],
           }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId
        });
        if (!data.hasComplete) {
          if (conditionType == 3 ) {
            this.percentage = Math.round(100*(data.amount/money));
          }
          this.openDialog(2);
          return
        }
        if (!data.hasReceive) {
          this.openDialog(4);
          return
        }
        this.openDialog(3);
        
      }).catch(error => {
        if (error.code && error.code == 1001) {
          // this.openDialog(4);
          this.$toast('请联系客服补充礼包码');
          try {
            this.eventTrack({
              event: "pay_active_get_gift",
              event_field: JSON.stringify({ 
                id: this.activityId,
                name: this.pageTitle,
                gift_id:giftId,
                gift_name:giftName,
                task_name: this.taskName[giftId],
              }),
              appName: this.curPlaceInfo.gameName,
              appkey: this.curPlaceInfo.gameId
            });
          } catch (error) {
            //
          }
        }
      })
    },
    // 打开弹窗
    openDialog(type, hasEvent = true){
      this.dialogVisible = true;
      this.dialogType = type;
      let popType = 0
      if (type == 1) {
        this.dialogTitle = '更多游戏';
        this.eventTrack({
          event: "pay_active_more_game",
          event_field: JSON.stringify({ id: this.activityId,name: this.pageTitle }),
        });
        return;
      }
      if (type == 2) {
        this.dialogTitle = '不满足领取条件';
        this.sureText = '去完成';
        popType = this.curGiftInfo.conditionType;
      }
      if (type == 3) {
        this.dialogTitle = '领取成功';
        this.sureText = '查看礼包码';
        if (!hasEvent) {
          return
        }
      }
      if (type == 4) {
        this.dialogTitle = '提示';
        this.sureText = '联系客服';
        popType = 5;
      }
      this.eventTrack({
        event: "pay_active_get_result_pop",
        event_field: JSON.stringify({ 
          id: this.activityId,
          name: this.pageTitle,
          gift_id:this.curGiftInfo.giftId,
          gift_name:this.curGiftInfo.giftName,
          task_name: this.taskName[this.curGiftInfo.giftId],
          type: popType
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId
      });
    },
    // 确认弹窗
    onSureDialog(){
      if (this.dialogType == 2) {
        this.onSkipDetail(this.curPlaceInfo.gameId, true);
        this.eventTrack({
          event: "pay_active_go_to_complete",
          event_field: JSON.stringify({ 
            id: this.activityId,
            name: this.pageTitle,
            gift_id:this.curGiftInfo.giftId,
            gift_name:this.curGiftInfo.giftName,
            task_name: this.taskName[this.curGiftInfo.giftId],
            type: this.curGiftInfo.conditionType,
          }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId
        });
      }
      if (this.dialogType == 3) {
        this.onGoGiftDetail();
      }
      if (this.dialogType == 4) {
        this.onRelationServer();
      }
      this.dialogVisible = false;
    },
    onCloseDialog(props){
      this.dialogVisible = false;
      if (props == 'btn') {
        this.eventTrack({
        event: "pay_active_get_gift_continue",
        event_field: JSON.stringify({ 
          id: this.activityId,
          name: this.pageTitle,
          gift_id:this.curGiftInfo.giftId,
          gift_name:this.curGiftInfo.giftName,
          task_name: this.taskName[this.curGiftInfo.giftId],
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId
      });
      }
    },
    // 游戏详情 
    onSkipDetail(gameId, isPop = false){
      if (!isPop) {
        this.eventTrack({
          event: "pay_active_look_game",
          event_field: JSON.stringify({ id: this.activityId,name: this.pageTitle }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId
        });
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: gameId
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);


    },
    // 礼包详情
    onGoGiftDetail() {
      this.eventTrack({
        event: "pay_active_look_gift",
        event_field: JSON.stringify({ 
          id: this.activityId,
          name: this.pageTitle,
          gift_id:this.curGiftInfo.giftId,
          gift_name:this.curGiftInfo.giftName,
          task_name: this.taskName[this.curGiftInfo.giftId],
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId
      });
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3, 
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 联系客服
    onRelationServer() {
      this.eventTrack({
        event: "pay_active_link_me",
        event_field: JSON.stringify({ 
          id: this.activityId,
          name: this.pageTitle,
          gift_id:this.curGiftInfo.giftId,
          gift_name:this.curGiftInfo.giftName,
          task_name: this.taskName[this.curGiftInfo.giftId],
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId
      });
      this.dialogVisible = false;
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 设置顶部内容
    setHeaderContent(){
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 649,
            activeRule: this.activityInfo.rule,
          },
        });
        // this.eventTrack({
        //   event: "pay_active_rule",
        //   event_field: JSON.stringify({ id: this.activityId,name: this.pageTitle }),
        // });
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>

.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f6f6f6;
  position: relative;

  .dialog1{
    max-height: 334px;
    overflow: auto;
    .dialogTitle{
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ff5216;
    }
    .dialogPlace{
      display: flex;
      flex-wrap: wrap;
      margin-top: 18px;
      
      .item{
        width: 32%;
        margin-bottom: 14px;
        position: relative;
      }
      .icon{
        width: 58px;
        height: 58px;
      }
      .name{
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
  }

  .dialog2{
    .progress {
      height: 8px;
      // background: #d43e41;
      border-radius: 8px;
      border: 1px solid #c73534;
      width: 80%;
      margin: 40px auto 50px;
      position: relative;
      .percentage {
        height: 7px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: linear-gradient(#ff756a 0%, #ffb46b 100%);
        border-radius: 6px;
      }
      .percentage::before{
        content: ".";
        position: absolute;
        top: -4px;
        right: 0;
        color: #c73534;
      }
      .text {
        font-size: 12px;
        color: #747474;
        font-weight: 500;
        position: absolute;
        top: -22px;
        width: auto;
        left: 0;
      }
      .amount {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        top: 8px;
        width: auto;
        margin-left: -10px;
      }
      // .amount::before{
      //   content: ".";
      //   position: absolute;
      //   top: -11px;
      //   left: 50%;
      // }
      .typeValue {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        right: -10px;
        top: 8px;
        width: auto;
      }
    }
    .progress::before {
        content: ".";
        color: #c73534;
        position: absolute;
        top: 0px;
        right:0%;
      }
  }
  .activityInfo {
    margin: 12px 12px 7px;
    .activityPlaces {
      width: 100%;
      height: 92px;
      background: #ffffff;
      border-radius: 14px;
      display: flex;
      align-items: flex-end;
      padding-bottom: 9px;
      position: relative;
      .placeIcon {
        width: 55px;
        margin-left: 10px;
      }
      .activePlace {
        width: 70px !important;
      }
      .morePlace {
        width: 58px;
        margin-left: 5px;
        text-align: center;
        > img {
          width: 40px;
        }
        .moreText {
          font-weight: 500;
          text-align: center;
          color: #fc5f5e;
          font-size: 12px;
          margin-top: 2px;
        }
      }
    }
  }

  .activityGifts {
    // width: 100vw;
    margin: 0 12px;
    height: calc(100vh - 128px);
    background: linear-gradient(180deg,#fff2e9 0%, #fbfbfa 100%);
    border-radius: 14px;
    margin-top: 15px;

    .gameInfo{
      display: flex;
      // padding: 0px 13px;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 8px;
      .title{
        font-size: 18px;
        font-weight: 500;
        color: #a1583e;
        height: 44px;
        line-height: 44px;
        text-align: center;
        padding: 0px 15px 0 11px;
        background: linear-gradient(180deg,#ffdac8 0%, #fff1e8 100%);
        border-radius: 14px 21px 21px 0px;
        width: 156px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
      .tag{
        min-height: 18px;
        line-height: 20px;
        padding: 0 9px;
        width: 68px;
        background: #ff6d6d;
        border-radius: 2px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        margin-left: 3px;
        position: absolute;
        left: 143px;
      }
      .button{
        width: 118px;
        height: 32px;
        line-height: 32px;
        background: linear-gradient(44deg,rgba(255,142,27,0.87) 0%, rgba(254,184,26,0.87) 90%);
        border-radius: 13px;
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        // margin-left: 88px;
      }
    }
    .giftList{
      padding: 4px 15px 0;
      overflow: scroll;
      height: calc(100vh - 185px);
      .giftItem{
        margin-bottom: 7px;
        background: #ffffff;
        border-radius: 7px;
        width: 100%;
        padding: 8px 6px 8px 12px;
        .icon{
          width: 43px;
        }
        .title{
          // width: 170px;
          line-height: 20px;
          font-size: 16px;
          font-weight: 700;
          text-align: left;
          color: #333333;
          margin-bottom: 4px;
        }
        .info{
          margin-left: 4px;
          .content{
            width: 170px;
            line-height: 16px;
            font-size: 12px;
            font-weight: 500;
            text-align: left;
            color: #9f7155;
            margin-top: 4px;
          }

        }
        .giftBtn{
          width: 84px;
          height: 32px;
          background: #ff9916;
          border: 1px solid #ffb017;
          border-radius: 15px;
          font-size: 16px;
          font-weight: 500;
          text-align: left;
          color: #ffffff;
          line-height: 32px;
          text-align: center;
          margin: 0 auto;
        }
        .disableBtn{
          filter: grayscale(100%);
        }
        .money{
          width: 95px;
          line-height: 13px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: #de482b;
          margin-top: 4px;
        }
      }
    }
  }
  .isPlay {
    position: absolute;
    top: -18px;
    left: 42px;
    background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 30px;
    line-height: 24px;
    font-size: 12px;
    color: #fefefe;
    width: 64px;
    text-align: center;
    z-index: 1;
  }
}
.pageNative {
  position: relative;
  height: calc(100vh - 1px);
  > img {
    width: 100%;
    height: calc(100vh - 1px);
  }
  .nativeStatus {
    width: 375px;
    height: 39.24px;
    line-height: 39.24px;
    position: absolute;
    top: calc(50% - 39px);
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    font-size: 18.75px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.1)
    );
    letter-spacing: 1px;
  }
}
</style>
